<template>
    <div>
        <div class="row" v-if="isInInitialState">
            <div class="col-sm-12">
                <p>
                    Har du en sluttande tomt? Tänk på att boytan minskar om du bygger souterränghus.
                </p>
                <p>Tips: mot fönsterlösa väggar kan det vara lämpligt att bygga förråd.</p>
                <br/>
            </div>
        </div>
        <div class="row houses-component">
            <house-list></house-list>
        </div>
        <hr/>
        <div class="row">
            <div class="row houses-component-summary" id="houses-summary">
                <div class="col-sm-12 text-center">
                    <h3>Sammanställning</h3>
                </div>
                <div class="col-sm-6">
                    <div class="form-group text-right">
                        <div class="control-label">Våningar</div>
                        <div class="summary-value">{{summary.floors}}</div>
                    </div>

                    <div v-for="apartment in summary.apartments" :index="apartment.sizeName+apartment.area"
                         class="form-group text-right">
                        <label class="control-label">{{apartment.sizeName}} ({{apartment.area}} kvm)</label>
                        <div class="summary-value">{{apartment.count}}</div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group text-left">
                        <label class="control-label">
                            BOA
                            <help-box message-ref="summary-boa" title="BOA"
                                      message="<strong>Boarea:</strong> Den yta som kan användas för boende och som bostadsföretaget kan få betalt för vid uthyrning. Mäts från ytterväggarnas insidor. Omfattar alla våningar ovan mark. Specialregler för sluttningsvåningar."></help-box>
                        </label>
                        <div class="summary-value">
                            {{ summary.livingArea.toLocaleString('sv-SE') }} kvm
                        </div>
                    </div>
                    <div class="form-group text-left">
                        <div class="text-box-container">
                            <label class="control-label">
                                LOA
                                <help-box message-ref="summary-loa" title="LOA"
                                          message="<strong>Lokalarea:</strong> Ytan för utrymmen som inrättats för annat ändamål än boende."></help-box>
                            </label>
                            <div class="text-box-container--inner validation-error-exclamation-mark">
                                <input :disabled="isProjectClosed" class="form-control"
                                       v-model.number="nonResidentialFloorArea" type="Number"
                                       @change="save" @keyPress="handleLoaKeyPress">
                            </div>
                            <span class="text-box-unit">kvm</span>
                            <div class="default-value">
                                Schablonvärde: {{ defaultNonResidentialFloorArea }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <saving-notification/>
    </div>
</template>

<script>
    import HouseList from "./components/houseList"
    import HelpBox from "./components/saboHelpBox"
    import SavingNotification from "./components/savingNotification"
    import {mapActions, mapGetters} from "vuex"
    import _ from "lodash"

    const commonArea = 0

    export default {
        computed: {
            ...mapGetters([
                "apartmentSizes",
                "supplierAddresses",
                "projectStateType",
                "procurementModel",
            ]),
            isInInitialState() {
                return this.projectStateType === 0;
            },
            // Summary
            summary() {
                const livingArea = function (houses) {
                    return houses.reduce(function (acc, house) {
                        return acc + house.apartments
                            .filter(apartment => apartment.apartmentSize !== commonArea)
                            .reduce(function (apAcc, apartment) {
                                return apAcc + (apartment.area * apartment.count);
                            }, 0);
                    }, 0);
                };

                const groupedApartments = function (houses) {
                    return houses.reduce(function (groups, house) {
                        house.apartments.forEach(function (apartment) {
                            const key = `${apartment.apartmentSize}-${apartment.area}`;
                            const count = groups[key] || 0;
                            groups[key] = count + apartment.count;
                        });
                        return groups;
                    }, {});
                };

                const numFloors = function (houses) {
                    return houses.reduce(function (acc, house) {
                        return acc + house.floors;
                    }, 0);
                };

                const groups = groupedApartments(this.$store.getters.houses);
                const groupedApartmentResults = [];

                const apartmentSizes = this.apartmentSizes
                Object.keys(groups).forEach(function (key) {
                    const sizeId = Number(key.split(/-/)[0]);
                    const area = key.split(/-/)[1];
                    groupedApartmentResults.push({
                        sizeName: _.find(apartmentSizes, ["id", sizeId]).label,
                        area: area,
                        count: groups[key]
                    });
                });

                return {
                    floors: numFloors(this.$store.getters.houses),
                    livingArea: livingArea(this.$store.getters.houses),
                    apartments: groupedApartmentResults
                };
            },
            nonResidentialFloorArea: {
                get() {
                    return this.$store.state.houses.nonResidentialFloorArea;
                },
                set(value) {
                    this.$store.commit("updateNonResidentialFloorArea", value);
                }
            },
            defaultNonResidentialFloorArea() {
                return this.$store.state.houses.houses
                    .reduce((total, house) => {
                        return total + house.apartments
                            .filter((apartment) => apartment.apartmentSize === commonArea)
                            .reduce((apartmentAcc, apartment) => {
                                return apartmentAcc + (apartment.area * apartment.count);
                            }, 0);
                    }, 0);
            },
            isProjectClosed() {
                return this.$store.getters.isProjectClosed;
            }
        },

        methods: {
            ...mapActions([
                'updateHouses',
            ]),
            save() {
                this.updateHouses()
            },
            handleLoaKeyPress(e) {
                if (e.keyCode === 13) {
                    e.preventDefault()
                    this.updateHouses()
                }
            },
        },

        components: {
            HouseList,
            HelpBox,
            SavingNotification,
        },
    }
</script>



// WEBPACK FOOTER //
// assets/vue/houseModel/houseModel.vue